import showdown from 'showdown';

const converter = new showdown.Converter();

// return html text without spans elements
export function extractSpanFromHtml(html: string) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const spans = doc.querySelectorAll('span');
  spans.forEach((span) =>
    span.firstChild
      ? span.parentNode?.replaceChild(span.firstChild, span)
      : null
  );
  return doc.body.innerHTML;
}

// move leading and trailing spaces from strong and em tags to the parent element
export function moveSpacesFromStrongAndEmTags(html: string) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const strongs = doc.querySelectorAll('strong');
  strongs.forEach((strong) => {
    if (strong.firstChild) {
      const text = strong.firstChild.textContent;
      if (text) {
        strong.firstChild.textContent = text.trim();
        if (text.startsWith(' ')) {
          strong.parentNode?.insertBefore(document.createTextNode(' '), strong);
        }
        if (text.endsWith(' ')) {
          strong.parentNode?.insertBefore(
            document.createTextNode(' '),
            strong.nextSibling
          );
        }
      }
    }
  });
  const ems = doc.querySelectorAll('em');
  ems.forEach((em) => {
    if (em.firstChild) {
      const text = em.firstChild.textContent;
      if (text) {
        em.firstChild.textContent = text.trim();
        if (text.startsWith(' ')) {
          em.parentNode?.insertBefore(document.createTextNode(' '), em);
        }
        if (text.endsWith(' ')) {
          em.parentNode?.insertBefore(
            document.createTextNode(' '),
            em.nextSibling
          );
        }
      }
    }
  });
  return doc.body.innerHTML;
}

// replace double new line with <p>&nbsp;</p>
export function replaceMarkDownEmptyNewLineWithHtmlNewLine(html: string) {
  return html.replace(/\r?\n\r?\n\r?\n\r?\n/g, '<p>&nbsp;</p>');
}

// make lines with spaces as new line
export function cleaningUpNewLinesWithSpaces(markdown: string) {
  return markdown.replace(/\r?\n\s+\r?\n/g, '<p>&nbsp;</p>');
}

// replace br tags with 4 new line
export function replaceBrTagsWith4NewLines(html: string) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const brs = doc.querySelectorAll('br');
  brs.forEach((br) => {
    br.parentNode?.insertBefore(
      document.createTextNode('\r\n\r\n\r\n\r\n'),
      br
    );
    br.parentNode?.removeChild(br);
  });
  return doc.body.innerHTML;
}

// replace \x3C! with < and \x3E! with >
export function replaceHtmlCommentTags(html: string) {
  return html.replace(/\\x3C!/g, '<').replace(/\\x3E!/g, '>');
}

// remove html comment tags from html
export function removeHtmlComments(html: string) {
  return html.replace(/(<!--.*?-->)|(<!--[\S\s]+?-->)|(<!--[\S\s]*?$)/g, '');
}

export const convertHtmlToMarkdown = (
  html: string | undefined
): string | undefined => {
  if (!html) return html;
  let middlePoints = html;

  middlePoints = replaceHtmlCommentTags(middlePoints);
  middlePoints = removeHtmlComments(middlePoints);
  middlePoints = moveSpacesFromStrongAndEmTags(middlePoints);
  middlePoints = replaceBrTagsWith4NewLines(middlePoints);

  let markdownText = converter.makeMarkdown(middlePoints);
  markdownText = replaceHtmlCommentTags(markdownText);
  markdownText = removeHtmlComments(markdownText);

  return markdownText;
};

export const convertMarkdownToHtml = (
  markdown: string | undefined
): string | undefined => {
  if (!markdown) return markdown;
  let middlePoints = markdown;

  middlePoints = replaceMarkDownEmptyNewLineWithHtmlNewLine(middlePoints);
  middlePoints = cleaningUpNewLinesWithSpaces(middlePoints);
  const html = converter.makeHtml(middlePoints);

  return html;
};
